import { render, staticRenderFns } from "./editarViagem.vue?vue&type=template&id=049fb52c"
import script from "./editarViagem.vue?vue&type=script&lang=js"
export * from "./editarViagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports